function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M8 16c4.418 0 8-3.582 8-8 0-4.419-3.582-8-8-8S0 3.58 0 8c0 4.418 3.582 8 8 8zM4.818 5.996c-.13-.13-.13-.341 0-.471l.707-.707c.13-.13.341-.13.471 0L8 6.82l2.003-2.003c.13-.13.342-.13.472 0l.707.707c.13.13.13.341 0 .471L9.178 8l2.004 2.003c.13.13.13.341 0 .472l-.707.707c-.13.13-.341.13-.472 0L8 9.178l-2.004 2.004c-.13.13-.34.13-.47 0l-.708-.707c-.13-.13-.13-.342 0-.472L6.821 8 4.818 5.996z",
  clipRule: "evenodd"
});

var SvgCrossInCircleFill = function SvgCrossInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrossInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-in-circle-fill.2ddac267.svg";
export { ForwardRef as ReactComponent };